import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import InfoIcon from 'components/core/InfoIcon';

/**
 * Render an entity header block.
 * ToolBar can be added as a child component.
 */
export default class EntityHeader extends React.Component {
    static propTypes = {
        children: PropTypes.any, // children may be an array of objects or a single object
        title: PropTypes.string,
        sideNote: PropTypes.string,
        count: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedItems: PropTypes.object,
        lastSelectedItem: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        className: PropTypes.string,
        infoboxMessage: PropTypes.any,
        tooltipPosition: PropTypes.string
    };

    render() {
        const className = this.props.className ? `${this.props.className} entity-header` : 'entity-header';

        let countString = '';
        if (this.props.count !== undefined && this.props.count !== null) {
            countString = `(${this.props.count})`;
        }

        let infoIcon = null;
        if (this.props.infoboxMessage) {
            infoIcon = <InfoIcon tooltipPosition={this.props.tooltipPosition} message={this.props.infoboxMessage}/>;
        }

        return (
            <Flexbox flexDirection="row" alignItems="center" className={className}>
                <div className="entity-title infobox">
                    {infoIcon}
                    {`${this.props.title} ${countString}`}
                    <em>{this.props.sideNote}</em>
                </div>
                {/* Pass my selected items down to my children */}
                {React.Children.map(this.props.children,
                    (child) => React.cloneElement(child, {
                        selectedItems: this.props.selectedItems,
                        lastSelectedItem: this.props.lastSelectedItem
                    })
                )}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/EntityHeader.js